import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = {
  key: 3,
  class: "card"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Configurar sessões")
], -1)
const _hoisted_4 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyAccount = _resolveComponent("MyAccount")!
  const _component_MyPlan = _resolveComponent("MyPlan")!
  const _component_ProfileSettings = _resolveComponent("ProfileSettings")!
  const _component_AvailabilitySettings = _resolveComponent("AvailabilitySettings")!
  const _component_BankAccount = _resolveComponent("BankAccount")!
  const _component_Notifications = _resolveComponent("Notifications")!
  const _component_Coupons = _resolveComponent("Coupons")!
  const _component_Support = _resolveComponent("Support")!
  const _component_AboutApp = _resolveComponent("AboutApp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.currentPath == 'minha-conta')
      ? (_openBlock(), _createBlock(_component_MyAccount, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.currentPath == 'meu-plano')
      ? (_openBlock(), _createBlock(_component_MyPlan, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.currentPath == 'gerenciar-perfil')
      ? (_openBlock(), _createBlock(_component_ProfileSettings, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.currentPath == 'configurar-sessoes')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_AvailabilitySettings, { type: "screen" })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentPath == 'conta-bancaria')
      ? (_openBlock(), _createBlock(_component_BankAccount, { key: 4 }))
      : _createCommentVNode("", true),
    (_ctx.currentPath == 'notificacoes')
      ? (_openBlock(), _createBlock(_component_Notifications, { key: 5 }))
      : _createCommentVNode("", true),
    (_ctx.currentPath == 'valor-personalizado')
      ? (_openBlock(), _createBlock(_component_Coupons, { key: 6 }))
      : _createCommentVNode("", true),
    (_ctx.currentPath == 'ajuda')
      ? (_openBlock(), _createBlock(_component_Support, { key: 7 }))
      : _createCommentVNode("", true),
    (_ctx.currentPath == 'sobre-o-app')
      ? (_openBlock(), _createBlock(_component_AboutApp, { key: 8 }))
      : _createCommentVNode("", true)
  ]))
}